import React from "react";
import ImageIcon from '../assets/icons/ImageIcon.svg'
import PdfIcon from "../assets/icons/PdfIcon.svg"
import DescriptionIcon from "@mui/icons-material/Description";
import GridOnIcon from "@mui/icons-material/GridOn";
import NotesIcon from "@mui/icons-material/Notes";
import TableChartIcon from "@mui/icons-material/TableChart";
import MovieIcon from "@mui/icons-material/Movie";

export const getIconBasedOnFileExt = (ext: string) => {
  switch (ext) {
    case "pdf":
      return <img src={PdfIcon} alt="pdf-icon" />;

    case "doc":
    case "docx":
      return <DescriptionIcon color="primary" />;

    case "xls":
    case "xlsx":
    case "csv":
      return <TableChartIcon style={{ color: "#4caf50" }} />;

    case "png":
    case "jpg":
    case "jpeg":
      return <img src={ImageIcon} alt="image-icon" />;

    case "txt":
      return <NotesIcon />;

    case "mp4":
      return <MovieIcon />;

    default:
      return <DescriptionIcon />;
  }
};
